<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 4L17 6C17 6.55229 16.4777 7 15.8333 7L4.16667 7C3.52234 7 3 6.55229 3 6L3 4C3 3.44772 3.52234 3 4.16667 3L15.8333 3C16.4777 3 17 3.44772 17 4Z"
      stroke="currentColor"
      stroke-width="1.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21 18L21 20C21 20.5523 20.3284 21 19.5 21L4.5 21C3.67157 21 3 20.5523 3 20L3 18C3 17.4477 3.67157 17 4.5 17L19.5 17C20.3284 17 21 17.4477 21 18Z"
      stroke="currentColor"
      stroke-width="1.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11 11L11 13C11 13.5523 10.602 14 10.1111 14L3.88889 14C3.39797 14 3 13.5523 3 13L3 11C3 10.4477 3.39797 10 3.88889 10L10.1111 10C10.602 10 11 10.4477 11 11Z"
      stroke="currentColor"
      stroke-width="1.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default { name: 'HorizontalBarChart' };
</script>

<style scoped lang="scss" type="text/scss">

</style>
